const PurchaseRequestRouter = [
    {
        path: "list-dashboard",
        name: "list",
        component: () => import("@/views/admin/dashboard"),
        default: true,
        meta: {
            model: "dashboard",
            // requiresAuth: true,
        },
    },
    {
        path: "list-dashboard/add",
        name: "add",
        component: () => import("@/views/admin/dashboard/function"),
        default: true,
        meta: {
            model: "dashboard",
            // requiresAuth: true,
        },
    },
    {
        path: "list-dashboard/edit/:id",
        name: "edit",
        component: () => import("@/views/admin/dashboard/function"),
        default: true,
        meta: {
            model: "dashboard",
            // requiresAuth: true,
        },
    },
  ];
  export default PurchaseRequestRouter;